import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface SizedContainerProps {
  className?: string;
  /**
   * Content to take the size from. `null` renders the children as they are,
   * so a caller can turn the sizing on and off without branching around this
   * component.
   */
  childrenForSize: ReactNode;
  children?: ReactNode;
}

/** Container that determines its size based on separate content. Use this to ensure a consistent size between many instances of the same component. */
export const SizedContainer: FC<SizedContainerProps> = (props) => {
  if (props.childrenForSize == null) {
    return <div className={props.className}>{props.children}</div>;
  }

  return (
    <div className={twMerge("relative", props.className)}>
      <div className="invisible" aria-hidden>
        {props.childrenForSize}
      </div>
      <div className="absolute inset-0">{props.children}</div>
    </div>
  );
};
